import { BaseEntity } from '../base/base';
import { ServiceName } from '../service-type';
export class LoyaltyMultiplier extends BaseEntity {
  multiplier: number;
  description: string;
  names: ServiceName[];
}
